import { ApiError } from './errors';

export type ApiRequestInit = Omit<RequestInit, 'headers' | 'body'> & {
  body?: unknown;
  headers?: Record<string, string>;
};

export type ApiClient = {
  request<T>(url: string, init?: ApiRequestInit): Promise<T>;
};

export function createApiClient(getToken: () => Promise<string | null>): ApiClient {
  return {
    async request<T>(url: string, init: ApiRequestInit = {}): Promise<T> {
      const token = await getToken();
      if (!token) {
        throw new ApiError(401, 'invalid_api_key', 'not authenticated');
      }
      const headers: Record<string, string> = {
        Authorization: `Bearer ${token}`,
        ...(init.headers ?? {}),
      };
      if (init.body !== undefined) headers['content-type'] = 'application/json';

      const res = await fetch(url, {
        ...init,
        headers,
        body: init.body === undefined ? undefined : JSON.stringify(init.body),
      });

      if (!res.ok) {
        let code = 'internal_error';
        let msg = `request failed with ${res.status}`;
        try {
          const payload = await res.json();
          if (typeof payload?.error === 'string') code = payload.error;
          if (typeof payload?.message === 'string') msg = payload.message;
        } catch { /* response body wasn't JSON */ }
        throw new ApiError(res.status, code, msg);
      }
      return (await res.json()) as T;
    },
  };
}
